import { wsEvent } from '@/socket/event'
import React from 'react'
import { addTextMsgToChatPanel, processMsg } from '@/proxy-request/process-msg'
import type { AllEvent } from '@/proxy-request/types'
import { generateUUID } from '@/utils'
import { getStores } from '@/stores'

const PROCESS_MSG_MODULES = ['video_create']

export const useAgentWs = () => {
  const { agentV2Store } = getStores()

  const checkMessageExists = (messageId: string): boolean => {
    const existsInRenderList = agentV2Store.renderMsgList.some(msg => msg.message_id === messageId)
    const existsInMessagesList = agentV2Store.messagesList.some(msg => msg.message_id === messageId)
    return existsInRenderList || existsInMessagesList
  }

  const getProcessMsgEventFromAgentWsPayload = (payload: {
    type?: string
    module?: string
    data?: {
      event_type?: string
      [key: string]: any
    }
  }) => {
    if (payload?.type !== 'agent') return null
    if (!payload?.module || !PROCESS_MSG_MODULES.includes(payload.module)) return null
    if (!payload?.data?.event_type) return null
    return payload.data as AllEvent
  }

  React.useEffect(() => {
    const handler = (data: {
      type: 'agent'
      module: string
      is_success: boolean
      data: any
      message_id: string
    }) => {
      const processMsgEvent = getProcessMsgEventFromAgentWsPayload(data)
      if (processMsgEvent) {
        processMsg(processMsgEvent, {
          renderToChatPanel: true
        })
        return
      }

      if (data.data) {
        const messageId = data?.message_id || generateUUID()
        const isMessageExists = checkMessageExists(messageId)

        if (!isMessageExists) {
          addTextMsgToChatPanel({
            content: data.data,
            message_id: messageId,
            is_first: true,
            finished: true
          })
        }
      }
    }

    wsEvent.addEventListener('agent', handler)
    return () => {
      wsEvent.removeEventListener('agent', handler as any)
    }
  }, [])
}
